export default {
  path: '/share',
  meta: {
    title: '邀请好友',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/share`),
}



// WEBPACK FOOTER //
// ./src/views/Share/router.js